// extracted by css-extract-rspack-plugin
export default {"sizeFluid":"100%","customDropdownContainer":"custom-dropdown__customDropdownContainer___DhVfi","isFluid":"custom-dropdown__isFluid___yz94i"};